// Recording-socket failure flag. The toast interpolates `error.message`, so it
// stays an app reaction; this file only writes the flag and the log.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { logger, sanitizeError } from '@heidi/runtime/logger';

import { GET_SESSION_BY_ID } from '../../contracts';
import { updateSessionById } from '../api/session';

type UseMutateUpdateSessionSocketErrorProps = {
  /** Fired where the destructive toast fired, with the same error. */
  onUpdateSocketError?: (error: Error) => void;
};

export function useMutateUpdateSessionSocketError({
  onUpdateSocketError,
}: UseMutateUpdateSessionSocketErrorProps = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    networkMode: 'offlineFirst',
    retry: 3,
    mutationKey: ['updateSessionSocketError'],
    mutationFn: async (sessionId: string) => {
      return await updateSessionById(sessionId, {
        had_ws_recording_failure: true,
      });
    },
    onSuccess: (sessionId) => {
      void queryClient.invalidateQueries({
        queryKey: [GET_SESSION_BY_ID, { sessionId }],
      });
    },
    onError: (error) => {
      logger.error('Error:', { error: sanitizeError(error) });
      onUpdateSocketError?.(error);
    },
  });
}
